import { render, staticRenderFns } from "./PurchaseTestimonials.vue?vue&type=template&id=2ac88f77"
import script from "./PurchaseTestimonials.vue?vue&type=script&lang=js"
export * from "./PurchaseTestimonials.vue?vue&type=script&lang=js"
import style0 from "./PurchaseTestimonials.vue?vue&type=style&index=0&id=2ac88f77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports